import React from 'react';
import styled, { keyframes } from 'styled-components'
import Logo from '../Components/Logo';
// import * as loader from '../Assets/Preloaders/238.gif'
import { useEffect, useState } from 'react';
import history from '../history.js'


const dimmer = keyframes`
from {
    opacity: 1
}

to {
    opacity: 0;
    
}
`
const SPLASHSCREEN = styled.section`
background-color: #a4508b;
background-image: linear-gradient(326deg, #a4508b 0%, #5f0a87 74%);
height: 100vh;
position: relative;
max-width: 100%;
animation ${dimmer} 2s;
animation-timing-function: ease-in-out;
 

`
const CENTER = styled.div`
position: absolute;
width: 100%;
display: flex;
background: transparent;
height: 100vh;
justify-content: center;
align-items: center;
 
  

 `
const BOTTOM = styled.div`
position: fixed;
display: flex;
justify-content: center;

top: 90vh;
width: 100%;
background: transparent;
align-items: center;
font-weight: bold;

`
const Splash = () => {
    const[count, setcount] = useState(0)

    const[timerID, setID] = useState(0)
useEffect(() => {document.title = 'Welcome to Wealth'})
    useEffect(() => {
        var interval = setInterval(() => setcount(count + 1), 1000)

        setID(interval)

         return () => clearInterval(interval)
    },[count])
    if(count === 3){
   clearInterval(timerID)
  history.push('/about')
 

    }
    return(

        <>
<SPLASHSCREEN>
    <CENTER> <Logo size='3rem' />
 </CENTER>

 <BOTTOM>
 {/* <img src={loader} alt='preloader' />  */}

 </BOTTOM>
   
       

     
</SPLASHSCREEN>

        </>
     
    )
} 
 
     
 
 
export default Splash;